import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import styles from "./BottomBar.module.css";
import { RootState } from "../../../../../store/common/store";
import { useSelector } from "react-redux";
import {
  getPageNumber,
  paginateCurrentSection,
} from "../../../../../store/pagination.slice";
import {
  useAppDispatch,
} from "../../../../../store/common/hooks";

const BottomBar: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { currentPage, totalPages, prevPageUrl, nextPageUrl } = useSelector(
    (state: RootState) => state.pagination
  );

  const [inputPage, setInputPage] = useState(currentPage);

  useEffect(() => {
    setInputPage(currentPage);
  }, [currentPage]);

  const handlePageChange = () => {
    if (
      !isNaN(inputPage) &&
      inputPage >= 1 &&
      inputPage <= totalPages &&
      inputPage !== currentPage
    ) {
      dispatch(paginateCurrentSection(inputPage));
    }
  };

  return (
    <div className={styles["pagination-container"]}>
      <button
        onClick={() => {
          const p = getPageNumber(prevPageUrl ?? "");
          dispatch(paginateCurrentSection(p));
        }}
        disabled={currentPage === 1}
        className={clsx({
          [styles["disabled"]]: currentPage === 1,
        })}
      >
        {t("newManager.prev")}
      </button>

      <span className={styles["page-input-wrapper"]}>
        {t("newManager.page")}
        <input
          className={styles["page-input"]}
          type="number"
          min={1}
          max={totalPages}
          value={inputPage}
          onChange={(e) => setInputPage(parseInt(e.target.value))}
          onKeyDown={(e) => {
            if (e.key === "Enter") handlePageChange();
          }}
          onBlur={handlePageChange}
        />
        {t("newManager.of")} {totalPages}
      </span>

      <button
        onClick={() => {
          const p = getPageNumber(nextPageUrl ?? "");
          dispatch(paginateCurrentSection(p));
        }}
        disabled={currentPage === totalPages || totalPages === 0}
        className={clsx({
          [styles["disabled"]]: currentPage === totalPages || totalPages === 0,
        })}
      >
        {t("newManager.next")}
      </button>
    </div>
  );
};

export default BottomBar;
